<template>
    <div>
        <!-- navigation card -->
        <template v-if="visibleCard">
            <v-card class="clientCallCard">
                <template>
                    <!-- cards image -->
                    <v-responsive class="dCard__img text-xs-center">
                        <v-avatar size="105">
                            <img v-bind:src="currentUser.avatar" />
                        </v-avatar>
                    </v-responsive>

                    <!-- personal data -->
                    <v-card-text class="pb-0">
                        <div class="dCard__subtitle">Личные данные</div>
                        <div class="dCard__data">{{ currentUser.city }}</div>
                    </v-card-text>

                    <!-- additional phones -->
                    <v-card-text
                        v-if="currentUser.phone_1 || currentUser.phone_1"
                    >
                        <div class="dCard__subtitle">
                            Дополнительные телефоны
                        </div>
                        <div class="dCard__data" v-if="currentUser.phone_1">
                            + {{ currentUser.phone_1 }}
                        </div>
                        <div class="dCard__data" v-if="currentUser.phone_2">
                            + {{ currentUser.phone_2 }}
                        </div>
                    </v-card-text>
                </template>
            </v-card>
        </template>
    </div>
</template>

<script>
import { bus } from '@/main';
export default {
    name: 'dispatcherInfo',

    data: () => ({
        visibleCard: false,
        currentUser: null,
        currentUserId: null,
    }),

    created: function () {
        bus.$on('toggle', (userId) => {
            this.currentUserId = userId;
            this.visibleCard = !this.visibleCard;
            this.calls();
        });
    },

    computed: {},

    methods: {
        calls() {
            for (const item of this.$store.getters['dispatcher/callsList']) {
                if (item.user.id == this.currentUserId) {
                    return (this.currentUser = item.user);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';

.clientCallCard {
    position: absolute;
    left: 20px;
    top: 70px;
    z-index: 999;
    min-width: 244px;
    padding-bottom: 15px;
}
</style>
